import { SelectionModel } from '@angular/cdk/collections';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PermissionsService } from 'libs/ng-ui/src/lib/_services/permissions.service';
import {
  AuthnService,
  CryptlexApiService,
  DataCacheService,
  OrganizationFormComponent,
  ResourceTableService,
} from 'ng-ui';
import {
  FilterableProperties,
  ResourceName,
  SEARCH_STRINGS,
  TableActions,
  TableColumn,
} from 'utils';

@Injectable({
  providedIn: 'root',
})
export class ResellerOrganizationService extends ResourceTableService {
  override resourceName: ResourceName = 'organization';
  get resourceApiPath() {
    const resellerId =
      this.dataCacheService.getCachedValues('profile').resellerId;
    return `/v3/resellers/${resellerId}/organizations`;
  }

  override get actions(): TableActions {
    return {
      create: true,
      delete: false,
      export: false,
      read: true,
      update: false,
      tag: false,
      search: true,
      selection: false,
      segments: false,
      menuActions: [
        {
          label: 'Edit',
          callback: this.launchUpdationDialog.bind(this),
          icon: 'EDIT',
        },
        {
          label: 'Delete',
          callback: this.launchDeletionDialog.bind(this),
          icon: 'DELETE',
        },
      ],
    };
  }

  override tableSearchPlaceholder: string = SEARCH_STRINGS.name;
  override tableEmptyMessage = 'No organizations found';

  override columns: TableColumn[] = [
    { property: 'name', displayType: 'text' },
    { property: 'email', displayType: 'text' },
    { property: 'allowedUsers', displayType: 'unlimitedCheck' },
    {
      property: 'updatedAt',
      displayType: 'date',
    },
  ];

  override selections: SelectionModel<any> = new SelectionModel<any>(false, []);
  override _columnIdsToDisplay: string[] = this.allColumnIds;
  override filterableProperties: FilterableProperties = {
    name: 'objectString',
    email: 'objectString',
  };
  constructor(
    api: CryptlexApiService,
    dialog: MatDialog,
    cache: DataCacheService,
    router: Router,
    public authnService: AuthnService,
    permissionsService: PermissionsService
  ) {
    super(api, dialog, cache, router, permissionsService);
  }
  override updationComponent = OrganizationFormComponent;
  override creationComponent = OrganizationFormComponent;
}
